import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames'
import css from './index.css'
import Button from '~/components/common/Button';
import {modalClose, modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import { setAlert } from '~/modules/user/actions';

class SetAlertOnce extends React.Component {
  constructor(props) {
    super(props)
  }

  refuseSetAlert =()=> {
    const {closePop, setAlert} = this.props;
    setAlert(false);
    closePop();
  }

  acceptSetAlert=()=> {
    const {showUpgradeToPremium} = this.props;
    showUpgradeToPremium();
  } 

  render() {
    return (
      <div className={css.popwrap}>
        <div className={css.title}>Set Load Alerts</div>
        <div className={css.message}>
          <p>'Set Load Alerts' is a Preferred membership feature.</p>
          <p>Do you want to upgrade your account and receive load alerts?</p>
        </div>
        <div className={css.buttonGroup}>
          <Button mods={['tall', 'action']} onClick={this.acceptSetAlert} className={css.button}>
            Yes, I want to upgrade
          </Button>
        </div>
        <div className={css.buttonGroup}>
          <Button mods={['tall']} onClick={this.refuseSetAlert} className={css.buttonCancel}>
            No, search loads without alerts
          </Button>
        </div>
      </div>
    );
  }
}

export default connect(null, mapDispatch({
  closePop: () => modalClose(modes.SET_ALERT_ONCE),
  setAlert : (props, flag) => setAlert(flag),
  showUpgradeToPremium: (props) => modalChange('pop', {
    source: "alert popup",
    type: 'pop_upgrade_to_premium',
  }),
}))(SetAlertOnce);


// WEBPACK FOOTER //
// ./src/components/Popup/SetAlertOnce/index.js